<template>
  <div class="c-container">
    <div>登陆发现更多精彩</div>
    <div class="mobile">156****9527</div>
    <div class="tips">认证服务由中国联通提供</div>

    <van-button type="primary" block class="btn login" @click="login"
      >一键登录</van-button
    >

    <!-- <van-button block class="btn">其他手机号码登陆</van-button> -->

    <div class="check">
      <van-checkbox
        v-model="checked"
        icon-size="16px"
        style="margin-right: 10px"
      >
        <div class="check-txt">
          已阅读并同意<a>用户协议</a>和<a>隐私政策</a>以及<a
            >中国联通认证服务条款</a
          >
        </div>
      </van-checkbox>
    </div>

    <van-popup v-model="showTips" class="tips-box">
      <div class="title">用户协议及隐私保护</div>
      <div class="check-txt">
        已阅读并同意<a>用户协议</a>和<a>隐私政策</a>以及<a
          >中国联通认证服务条款</a
        >
      </div>
      <div class="dy-tip">抖音将严格保护你的个人信息安全</div>

      <van-button type="primary" block class="btn login" @click="checked=true;login()"
        >同意并登陆</van-button
      >
      <div class="grey" @click="showTips=false">不同意</div>
    </van-popup>
  </div>
</template>
<script>
import "vant/lib/index.css";
import { Button, Checkbox, Popup } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
  },
  data() {
    return {
      checked: false,
      showTips: false,
    };
  },
  methods: {
    login() {
      if (!this.checked) {
        this.showTips = true;
        return;
      }

      this.$router.push('me')
    },
  },
};
</script>
<style lang="less">
html,
#app {
  height: 100%;
}
</style>
<style lang="less" scoped>
.c-container {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .mobile {
    font-size: 32px;
    margin: 10px 0;
  }

  .tips {
    font-size: 12px;
    color: #666666;
  }

  .btn {
    margin-bottom: 10px;
    width: 90%;
  }

  .login {
    background-color: #f83257;
    border-color: #f83257;
    margin-top: 50px;
  }

  .check {
    margin-top: 6px;
    width: 90%;
    ::v-deep .van-checkbox {
      align-items: flex-start;
      .van-checkbox__icon {
        margin-top: 4px;
      }
    }
  }

  .check-txt {
    color: #666666;
    font-size: 12px;

    a {
      margin: 0 4px;
      color: #206bad;
    }
  }

  .tips-box {
    background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;
    width: 70%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
        font-weight: bold;
    }

    .check-txt {
        margin-top: 10px;
    }

    .dy-tip {
        font-size: 13px;
        font-weight: 500;
        margin-top: 10px;
    }
    .login {
        margin-top: 10px;
    }
  }

  .grey {
      cursor: pointer;
      color: grey;
  }
}
</style>